import React from 'react';
import Hero from './Hero';
import Video from './Video';
import Pricing from './Pricing';
import LandingFaq from './LandingFaq';
import VideoGuidelines from './VideoGuidelines';

function LandingPage() {
  return (
    <div className="App landing-page-wrap">
      <Hero />
      <Video />
      <Pricing />
      <LandingFaq />
      <VideoGuidelines />
    </div>
  );
}

export default LandingPage;

